import {useAuth} from '../auth';
import {useEffect,useState} from 'react';
import {Navigate,useParams,useSearchParams} from 'react-router';
import {api} from '../api';
import {Loading,ErrorState,reviewedApplicationError} from '../ui/State';
import {withBuildingScope} from '../ui/building-scope';
import './onboarding.css';
type Programme={id:string;development_id:string;version:number};

/** Old links only. Onboarding is chosen from the Buildings register; a programme link opens its building's onboarding. */
export function ClientOnboarding(){
 const {config}=useAuth(),journey=config?.buildingOnboardingEnabled?'onboarding':'setup';
 const {id}=useParams(),[params]=useSearchParams(),building=params.get('building')??undefined;
 const [programme,setProgramme]=useState<Programme>(),[error,setError]=useState<unknown>(),[revision,setRevision]=useState(0);
 useEffect(()=>{if(!id)return;const controller=new AbortController();setProgramme(undefined);setError(undefined);
  void (async()=>{
   const value=await api<{programme:Programme}>(withBuildingScope(`/api/client-onboarding/${id}`,building),{signal:controller.signal});
   if(value.programme.id!==id||building&&value.programme.development_id!==building||!value.programme.development_id)throw reviewedApplicationError('The onboarding response does not match this building.');
   if(!Number.isSafeInteger(value.programme.version)||value.programme.version<1)throw reviewedApplicationError('The handover response is older than the last recorded version. Retry to load current information.');
   if(!controller.signal.aborted)setProgramme(value.programme);
  })().catch(cause=>{if(!controller.signal.aborted)setError(cause)});return()=>controller.abort();
 },[id,building,revision]);
 if(!id)return <Navigate replace to={building?withBuildingScope(`/buildings/${building}/${journey}`,building):'/buildings?onboarding=open'}/>;
 if(error)return <ErrorState error={error} onRetry={()=>setRevision(n=>n+1)}/>;
 if(!programme||programme.id!==id||building&&programme.development_id!==building)return <Loading heading="Loading building handover"/>;
 const next=new URLSearchParams(params);next.set('building',programme.development_id);next.set('handoverProgramme',programme.id);
 return <Navigate replace to={`/buildings/${programme.development_id}/${journey}?${next}`}/>;
}
